import React from 'react';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import {
  Button,
  FocusTrap,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import {
  modals,
} from '@mantine/modals';
import {
    useQueryClient,
} from '@tanstack/react-query';
import {
    createFileRoute,
} from '@tanstack/react-router';

import {
    resolveObject,
} from '@specia-accountant/shared';
import {
  stripePromise,
} from '#src/types/stripe';
import {
  PaymentSetup,
} from '#features/payment/PaymentSetup';
import {
  PaymentType,
  type PaymentTypeProps,
} from '#features/payment/PaymentType';
  // loader: async ({
  //   context,
  // }) => {
  //   return resolveObject({
  //     stripe: stripePromise,
  //   });
  // },
export const Route = createFileRoute('/_app/_authenticated/settings/payment')({
  component: RouteComponent,
  loader: async (opts) => {
    const paymentMethods = opts.context.queryClient.ensureQueryData({
      queryKey: [
        'stripe',
        'payment-method',
      ],
    });
    return await resolveObject({
      stripe: stripePromise,
      paymentMethods,
    });
  },
});

function RouteComponent(): React.ReactNode {
  const {
    paymentMethods,
    stripe,
  } = Route.useLoaderData() as any;
  const queryClient = useQueryClient();
  return (
    <Stack
      mx="md"
    >
      <Title
        order={ 4 }
      >
        Payment
      </Title>
        <Text
          size="lg"
          c="transparent.4"
        >
          Manage payment details
        </Text>

        <Button
          onClick={ () => {
            const modalId = modals.open({
              closeOnClickOutside: true,
              withCloseButton: true,
              withinPortal: false,
              title: (
                <div
                  style={ {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  } }
                >
                  <ShoppingBasketIcon />
                  <Text
                    size="xl"
                    style={ {
                      marginLeft: '0.7vw',
                    } }
                  >
                    Add Payment Method
                  </Text>
                </div>
              ),
              children: (
                <>
                  <FocusTrap.InitialFocus />
                  <PaymentSetup
                    reloadHandler={ () => {
                      queryClient.invalidateQueries({
                        queryKey: [
                          'stripe',
                          'payment-method',
                        ],
                      });
                    } }
                    closeModalHandler={ () => { modals.close(modalId); } }
                  />
                </>
              ),
            });
          } }
        >
          Add Card
        </Button>
      <div
        style={ {
          textAlign: 'right',
        } }
      >
        { paymentMethods.map((item: PaymentTypeProps) => (
          <PaymentType
            key={ item.paymentMethodId }
            { ...item }
          />
        )) }
      </div>
    </Stack>
  );
}
